import type { SpeakingPrompt } from '../types';
import { coursePlanLessons } from './coursePlan';

const modeFor = (level: SpeakingPrompt['level'], lessonNumber: number): SpeakingPrompt['mode'] => {
  if (level === 'Beginner') return lessonNumber % 3 === 0 ? 'Describe' : 'Answer question';
  if (level === 'A1') return lessonNumber % 4 === 0 ? 'Role-play' : 'Mini interview';
  if (level === 'A2') return lessonNumber % 2 === 0 ? 'Role-play' : 'Describe';
  if (level === 'B1') return lessonNumber % 3 === 0 ? 'Role-play' : 'Opinion';
  return lessonNumber % 4 === 0 ? 'Mini interview' : 'Opinion';
};

const promptByLevel = {
  Beginner: (title: string) => `Say 3 simple sentences about ${title.toLowerCase()}.`,
  A1: (title: string) => `Answer 4 questions in a short dialogue about ${title.toLowerCase()}.`,
  A2: (title: string) => `Describe a real situation about ${title.toLowerCase()} and ask one follow-up question.`,
  B1: (title: string) => `Give your opinion about ${title.toLowerCase()} with one reason and one example.`,
  B2: (title: string) => `IELTS-style long turn: speak for 1-2 minutes about ${title.toLowerCase()}, then discuss one wider issue.`,
  C1: (title: string) => `Professional discussion: present a nuanced position on ${title.toLowerCase()} and respond to a counterargument.`,
} as const;

export const speakingPrompts: SpeakingPrompt[] = coursePlanLessons.map((lesson) => ({
  id: `s-${lesson.id}`,
  level: lesson.level,
  mode: modeFor(lesson.level, lesson.lessonNumber),
  prompt: promptByLevel[lesson.level](lesson.title),
  usefulWords: [lesson.category, lesson.grammarFocus, lesson.example.en.split(' ')[0] ?? 'example'],
  modelAnswer: lesson.level === 'B2' || lesson.level === 'C1'
    ? `${lesson.example.en} This point needs evidence, a counterargument and a careful conclusion.`
    : lesson.example.en,
  checklist: lesson.level === 'Beginner' || lesson.level === 'A1'
    ? ['Use short complete sentences', 'Say the key phrase aloud', 'Check the Russian meaning', 'Repeat once more slowly']
    : ['Answer the task directly', 'Use lesson vocabulary', 'Add a reason or example', 'Finish with a clear final idea'],
}));
